export const en = {
  formFields: {
    locationCityNeighborhood: 'Nonprofit address or meeting point',
    yourCityOfResidence: 'Your city of residence',
    maxLocationsError: 'You can only enter a max of {{limit}} locations.',
    selectCompanyRegions: 'Select company regions...',
    selectedCompanyRegions: 'Selected Company Regions',
    regionAlreadySelected: 'This region has already been selected',
    maxRegionsError: 'Maximum of {{limit}} regions allowed',
    dateSingleSelectField: {
      isPast: "You've selected a date in the past. This event will only appear in past events when filtering.",
    }
  },
}
